export default __webpack_public_path__ + "static/media/vegetation.dcb6a1f7.png";